<div class="row" [formGroup]="form">
  @if (question.controlType != 'checkbox') {
    <div class="col-sm-12 d-flex mb-2" [attr.for]="question.key">
      <div class="input-label mb-0" [innerHTML]="question.label"></div>
      @if (question.hoverText) {
        <div class="ml-2 hover-dropdown" ngbDropdown placement="bottom-right">
          <div class="pitchin-icon pitchin-icon-info-icon-grey no-caret" ngbDropdownToggle></div>
          <div
            class="font-size-smaller hover-text-panel p-3"
            ngbDropdownMenu
            [innerHTML]="question.hoverText"
          ></div>
        </div>
      }
    </div>
  }

  @if (question.description) {
    <div class="col-sm-12 input-description" [innerHTML]="question.description"></div>
  }

  <div
    class="input-field"
    [class]="inputClass"
    [class.date-input]="question.controlType == 'datepicker'"
  >
    @switch (question.controlType) {
      @case ('textbox') {
        @if (question.key == 'phoneNumber') {
          <input
            class="form-control"
            [formControlName]="question.key"
            [id]="question.key"
            type="text"
            [readonly]="question.readonly"
            [placeholder]="question.placeholder"
            digitOnly
            minlength="7"
            maxlength="15"
          />
        }
        @if (question.type == 'number') {
          <input
            class="form-control"
            [formControlName]="question.key"
            [id]="question.key"
            type="text"
            [readonly]="question.readonly"
            [placeholder]="question.placeholder"
            [pattern]="
              question.type == 'number'
                ? question.allowNegatives
                  ? OneBillionPatternAllowNegative
                  : OneBillionPattern
                : question.pattern
            "
            digitOnly
            decimal="true"
            [allowNegatives]="question.allowNegatives"
            allowPaste="false"
          />
        }
        @if (question.type != 'number' && question.key != 'phoneNumber') {
          <input
            class="form-control"
            [formControlName]="question.key"
            [id]="question.key"
            [type]="question.type"
            [readonly]="question.readonly"
            [pattern]="question.pattern"
            [placeholder]="question.placeholder"
          />
        }
      }
      @case ('currency') {
        <div class="input-field position-relative">
          <div class="position-absolute text-black font-weight-bold currency">
            {{ 'investment.rm' | translate }}
          </div>
          <input
            class="form-control pl-5"
            [formControlName]="question.key"
            [id]="question.key"
            type="text"
            [readonly]="question.readonly"
            [placeholder]="question.placeholder"
            digitOnly
            decimal="true"
            [allowNegatives]="question.allowNegatives"
            allowPaste="false"
            [pattern]="
              question.allowNegatives
                ? OneBillionWithTwoDecimalPatternAllowNegative
                : OneBillionWithTwoDecimalPattern
            "
          />
        </div>
      }
      @case ('percentage') {
        <div class="input-field position-relative">
          <input
            class="form-control pr-5"
            [formControlName]="question.key"
            [id]="question.key"
            type="text"
            [readonly]="question.readonly"
            [placeholder]="question.placeholder"
            digitOnly
            decimal="true"
            [allowNegatives]="question.allowNegatives"
            allowPaste="false"
            [pattern]="
              question.allowNegatives
                ? OneBillionWithTwoDecimalPatternAllowNegative
                : OneBillionWithTwoDecimalPattern
            "
          />
          <div class="position-absolute text-black font-weight-bold percent">%</div>
        </div>
      }
      @case ('dropdown') {
        <mat-select
          [placeholder]="'common.selectPlaceholder' | translate"
          class="form-control"
          [id]="question.key"
          [formControlName]="question.key"
          [disabled]="question.readonly"
          (selectionChange)="onOptionChanged($event.value)"
        >
          @for (opt of question.options; track opt) {
            <mat-option [value]="opt.key">
              {{ opt.value }}
            </mat-option>
          }
        </mat-select>
      }
      @case ('radio-boolean') {
        <mat-radio-group
          [id]="question.key"
          [formControlName]="question.key"
          [disabled]="question.readonly"
          (change)="onOptionChanged($event.value)"
        >
          @for (opt of question.options; track opt) {
            <mat-radio-button [value]="opt.key">
              {{ opt.value }}
            </mat-radio-button>
          }
        </mat-radio-group>
      }
      @case ('textarea') {
        <textarea
          class="form-control"
          rows="3"
          [id]="question.key"
          [formControlName]="question.key"
          [readonly]="question.readonly"
          [placeholder]="question.placeholder"
        ></textarea>
      }
      @case ('selection-list') {
        <mat-selection-list
          [id]="question.key"
          [formControlName]="question.key"
          [disabled]="question.readonly"
          (selectionChange)="onSelectionListChanged()"
        >
          @for (opt of question.options; track opt) {
            <mat-list-option
              class="list-option"
              [value]="opt.key"
              checkboxPosition="before"
              [disableRipple]="true"
            >
              {{ opt.value }}
            </mat-list-option>
          }
        </mat-selection-list>
      }
      @case ('datepicker') {
        <input
          class="form-control"
          [matDatepicker]="datepicker"
          [formControlName]="question.key"
          [name]="question.key"
          placeholder="DD/MM/YYYY"
          [readonly]="question.readonly"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="datepicker"
          disableRipple
          [disabled]="question.readonly"
        >
          <div class="pitchin-icon pitchin-icon-calendar ml-3" matDatepickerToggleIcon></div>
        </mat-datepicker-toggle>
        <mat-datepicker #datepicker></mat-datepicker>
      }
      @case ('checkbox') {
        <mat-checkbox
          [formControlName]="question.key"
          [id]="question.key"
          [disabled]="question.readonly"
        >
          <span class="input-label">
            {{ question.label }}
          </span>
        </mat-checkbox>
      }
    }
  </div>
</div>
